<template>

  <div>

    <v-snackbar
      id="next-payment-success-snackbar"
      v-model="snackbar.show"
      color="success"
      :multi-line="true"
      :timeout="snackbar.timeout"
      class="text-xs-center"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <div v-if="(!!clients)">
      <ClientListDialog v-if="showClientListDialog" v-model="showClientListDialog" :clients="clients" ></ClientListDialog>
    </div>

    <!--     Your Clients Card     -->
    <v-card color="white" class="card-border text-xs-left">
      <v-system-bar height="45" window color="itoviGrayLight">
        <h2 class="card-header-text">Your Clients</h2>
        <v-spacer></v-spacer>
      </v-system-bar>

      <div v-if="!(!!clients)" class="pa-4">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
      <div class="card-body" v-if="!!clients">

        <div class="txt-bold">
          You have {{ !!clients ? clients.length : 0 }} client{{ clients.length === 1 ? '' : 's' }}
        </div>

        <div class="text-xs-center pt-3">
          <v-btn round outline color="primary" @click="generateCSV">
            Download CSV
          </v-btn>
        </div>
        <div class="text-xs-center pt-1">
          <v-btn round outline color="primary" @click="showClientListDialog = true">
            View Clients
          </v-btn>
        </div>

      </div>


    </v-card>

  </div>

</template>


<style lang="scss">
  .strikethrough {
    text-decoration: line-through;
    color: orange;
  }
</style>

<script>
  import api from "../../../services/api_endpoints";
  import store from '../../../store';
  import moment from 'moment';
  import ClientListDialog from './ClientListDialog'

  export default {
    components: {
      ClientListDialog,
    },
    data: ()=> ({
      snackbar: {
        show: false,
        timeout: 2500,
        message: "Link copied to clipboard"
      },
      showClientListDialog: false,
      clients: store.state.clients,
      is_mobile_app_webview: false,
    }),
    created(){
      this.fetchClients()
    },
    mounted() {
      // subscribe to changes on the state
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setClients') {
          this.clients = state.clients
        }
      });
      this.is_mobile_app_webview = this.$route.query.hasOwnProperty('apptoken');
    },
    methods: {
      async fetchClients() {
        await api.getClients();
      },
      removeCommas(string) {
        return string.replace(/,/g, '，');
      },
      generateCSV() {
        let csvContent = `data:text/csv;charset=utf-8,Last Name,First Name,Email,Phone,Scan Count,Last Scan\n`;

        for (let i = 0; i < this.clients.length; i++) {
          let client = this.clients[i];

          let dataString = `${this.removeCommas(client.last_name)},`;
          dataString += `${this.removeCommas(client.first_name)},`;
          dataString += `${this.removeCommas(client.email)},`;
          dataString += `${Object.prototype.hasOwnProperty.call(client, 'phone') ? this.removeCommas(client.phone) : ''},`;

          let numScans = 0;
          let lastScanDate = '';
          if (client.recent_scan && Array.isArray(client.recent_scan) && client.recent_scan.length > 0) {
            numScans = client.recent_scan.length;
            lastScanDate = moment(client.recent_scan[0].scan_date.date).format('MMMM Do YYYY');
          }
          dataString += `${numScans},`;
          dataString += lastScanDate;

          if (i < this.clients.length) dataString += "\n";

          csvContent += dataString;
        }

        console.log(csvContent);

        let encodedUri = encodeURI(csvContent);
        window.open(encodedUri, '_self');
      },
    },
  }
</script>
